export const tableHeaderStyles = {
  color: "white",
  textAlign: "center" as const,
  fontSize: "xs",
  py: 5,
  px: 1,
  fontFamily: "Lexend Deca",
  _notLast: {
    borderRight: "1px solid",
    borderColor: "whiteAlpha.400",
  },
};

// Mesmo header colorido, porém mais fino (menos padding vertical) — usado no
// redesign de Vínculos Ativos, sem afetar as tabelas que já usam
// tableHeaderStyles em outras telas.
export const tableHeaderStylesThin = {
  ...tableHeaderStyles,
  py: 2,
  fontSize: "xs",
};

export const tableCellStyles = {
  textAlign: "center" as const,
  fontFamily: "Lexend Deca",
  fontSize: "14px",
  fontWeight: "normal" as const,
  px: 1,
};

// Par do tableHeaderStylesThin — fonte menor que o header, mesmo escopo
// (redesign de Vínculos Ativos).
export const tableCellStylesThin = {
  ...tableCellStyles,
  fontSize: "xs",
};

export const EDGE_COLUMN_PX = 4;

/**
 * Estilo de botão chapado (cor sólida), com texto branco.
 * Use com um colorScheme que tenha escala (green, red, blue, teal...).
 */
export const tagButtonStyle = (scheme: string) => ({
  bg: `${scheme}.500`,
  color: "white",
  borderRadius: "md",
  _hover: { bg: `${scheme}.600` },
  _active: { bg: `${scheme}.700` },
  _disabled: {
    opacity: 0.4,
    cursor: "not-allowed",
    _hover: { bg: `${scheme}.500` },
  },
});
